module.exports = __webpack_public_path__ + "img/Nicht ausgebaut.1e752707.svg";